import req from '@/utils/request.config'
export default {
  datePicKey:()=>{
    if(document.getElementById('forKeydown')){
      document.getElementById('forKeydown').focus();
    }
  },
  del : (check, url, fn,ele,searchValue) =>{
    if(check.constructor===Array){
      if (check.length > 0) {
        ele.$confirm('确定要删除吗？', '提示', {
          confirm: '确定', cancel: '取消', type: 'warning'
        }).then(() => {
          req.delete(url, check).then((res) => {
            if (res.data.success) {
              ele.$message.success('删除成功！');
              if(searchValue){
                searchValue.current=1;
              }else{
                ele.searchValue.current=1;
              }
              ele[fn]();

            } else {
              /*  ele.$message({
                  message: res.data.msg,
                  type: 'warning',
                  duration: 3000
                });*/
            }
          })
        }) .catch(o => {})
      } else {
        ele.$message.warning('请至少选择一条进行删除！')
      }

    }else{
      if (check.ids.length > 0) {
        ele.$confirm('确定要删除吗？', '提示',
          {
          confirm: '确定', cancel: '取消', type: 'warning'
        }).then(() => {
          req.delete(url, check).then((res) => {
            if (res.data.success) {
              ele.$message.success('删除成功！');

              if(searchValue){
                searchValue.current=1;
              }else{
                ele.searchValue.current=1;
              }
              ele[fn]();
            } else {
              /*  ele.$message({
                  message: res.data.msg,
                  type: 'warning',
                  duration: 3000
                });*/
            }
          })
        }) .catch(o => {})
      } else {
        ele.$message.warning('请至少选择一条进行删除！')
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/static/delTabCheck.js